import { axiosPost } from '@/api/handlers';
import { useMutation } from '@/api/hooks';

export const useUploadPaymentGroup = () => {
  return useMutation({
    mutationFn: async ({
      projectId,
      csvData,
    }: {
      projectId: string;
      csvData: (string | number)[][];
    }) => {
      return await axiosPost(
        `/api/projects/${projectId}/payment-groups/csv-upload/`,
        { csv: csvData },
      );
    },
  });
};
